import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={38}
    height={39}
    viewBox="0 0 38 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_7171_19964)">
      <circle cx={19} cy={15.5} r={15} fill="white" />
      <path
        d="M14.8692 20.4999C14.6467 20.4999 14.4243 20.415 14.2546 20.2453C13.9151 19.9058 13.9151 19.3554 14.2546 19.016L22.5159 10.7547C22.8553 10.4152 23.4057 10.4152 23.7452 10.7547C24.0846 11.0941 24.0846 11.6446 23.7452 11.984L15.4839 20.2453C15.3142 20.4151 15.0917 20.4999 14.8692 20.4999ZM23.1308 20.4998C22.9083 20.4998 22.6858 20.415 22.5161 20.2453L14.2546 11.9839C13.9151 11.6445 13.9151 11.094 14.2546 10.7546C14.594 10.4152 15.1445 10.4151 15.4839 10.7546L23.7454 19.0159C24.0849 19.3554 24.0849 19.9058 23.7454 20.2453C23.5757 20.4151 23.3533 20.4999 23.1308 20.4999V20.4998Z"
        fill="#1D1D1D"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_7171_19964"
        x={0}
        y={0.5}
        width={38}
        height={38}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7171_19964"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7171_19964"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SVGComponent;
